import request from '@/utils/request'

/**
 * 运营中心告警统计
 * @param {Object} params - 查询参数
 * @param {string} params.startTime - 开始时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.endTime - 结束时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {number} params.stationId - 电站ID
 * @returns {Promise} 返回告警统计数据
 */
export function getOperationCenterStatistics(params) {
  return request({
    url: '/dashboard/v3/operationCenter/statistics',
    method: 'get',
    params
  })
}

/**
 * 运营中心国标费率（电价时段）
 * @param {Object} params - 查询参数
 * @param {string} params.startTime - 开始时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.endTime - 结束时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {number} params.stationId - 电站ID
 * @returns {Promise} 返回电价信息数据
 */
export function getOperationCenterStandardRate(params) {
  return request({
    url: '/dashboard/v3/operationCenter/standardRate',
    method: 'get',
    params
  })
}

/**
 * 负荷分析
 * @param {Object} params - 查询参数
 * @param {string} params.startTime - 开始时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.endTime - 结束时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {number} params.stationId - 电站ID
 * @returns {Promise} 返回负荷分析数据
 */
export function getLoadAnalysis(params) {
  return request({
    url: '/dashboard/v3/curve/loadAnalysis',
    method: 'get',
    params
  })
}

